import FullScreenLoader from "components/Dashboard/FullScreenLoader";
import React, { useCallback, useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { getLoan } from "services/LoanService";

import LoanProTab from "./LoanProTab";

const LoanDetailsComp = () => {
  const router = useNavigate();
  const params = useParams();
  const queryClient = useQueryClient();

  const {
    data: response,
    isLoading,
    refetch,
  } = useQuery(
    ["loan", params?.id],
    () => getLoan(params?.id),
    {
      keepPreviousData: true, // 👈 smoother transitions
    }
  );

  const hasNext = response?.data?.hasNext;
  const hasPrev = response?.data?.hasPrev;
  const prevId = response?.data?.prevId;
  const nextId = response?.data?.nextId;

  // 🔥 Prefetch next & prev loans
  useEffect(() => {
    if (nextId) {
      queryClient.prefetchQuery(
        ["loan", nextId],
        () => getLoan(nextId),
        { staleTime: 1000 * 60 * 5 }
      );
    }

    if (prevId) {
      queryClient.prefetchQuery(
        ["loan", prevId],
        () => getLoan(prevId),
        { staleTime: 1000 * 60 * 5 }
      );
    }
  }, [nextId, prevId, queryClient]);

  const goToNext = useCallback(() => {
    if (nextId) {
      router(`/loan/loan-details/${nextId}`);
    }
  }, [nextId, router]);

  const goToPrev = useCallback(() => {
    if (prevId) {
      router(`/loan/loan-details/${prevId}`);
    }
  }, [prevId, router]);

  if (isLoading || !response) return <FullScreenLoader />;

  return (
    <div>
      <header className="flex justify-end my-4 px-4">
        <div className="flex items-center gap-3 bg-white shadow-sm border rounded-full px-4 py-2">
          <button
            onClick={goToPrev}
            disabled={!hasPrev}
            className="px-4 py-2 flex items-center gap-2 text-sm font-medium
              rounded-full hover:bg-gray-100 border transition
              disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <i className="bi bi-arrow-left text-base"></i>
            Prev
          </button>

          <div className="h-5 w-px bg-gray-300"></div>

          <button
            onClick={goToNext}
            disabled={!hasNext}
            className="px-4 py-2 flex items-center gap-2 text-sm font-medium
              rounded-full hover:bg-gray-100 border transition
              disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Next
            <i className="bi bi-arrow-right text-base"></i>
          </button>
        </div>
      </header>

      <LoanProTab
        recentLoan={response.data.recent_loans}
        loan={response.data.loan}
        getLoan={refetch}
      />
    </div>
  );
};

export default LoanDetailsComp;
